var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 0C6.98762 0 2.00012 4.09097 2.00012 10.418C2.00012 14.4581 5.21575 19.2098 11.6339 24.6856C12.1326 25.1048 12.8807 25.1048 13.3795 24.6856C19.7845 19.2098 23.0001 14.4581 23.0001 10.418C23.0001 4.09097 18.0126 0 12.5001 0ZM12.5001 12.7049C11.0564 12.7049 9.87512 11.5614 9.87512 10.1639C9.87512 8.76636 11.0564 7.62292 12.5001 7.62292C13.9439 7.62292 15.1251 8.76636 15.1251 10.1639C15.1251 11.5614 13.9439 12.7049 12.5001 12.7049Z",
    fill: "#20C5B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLocation);
export default __webpack_public_path__ + "static/media/dashboard_location.6c942693c4256e1c7c90d368d5b131d0.svg";
export { ForwardRef as ReactComponent };